// extracted by mini-css-extract-plugin
module.exports = {"container":"RamadanActivities_container__vMBhV","verseContainer":"RamadanActivities_verseContainer__N3B96"};